(ns minorodata.components.transformations.core
  (:require [minorodata.app.handlers :refer [dispatch dispatch-sync]]
            [minorodata.components.transformations.groups :refer [groups-sidebar]]
            [minorodata.components.transformations.header :refer [header]]
            [minorodata.components.transformations.transforms :refer [transforms]]
            [minorodata.transform-environments.model :refer [->environments-panel]]
            [re-posh.core :as re-posh]
            [reagent.core :as reagent]
            [ui.page :refer [page-content page-header page-root]]))

(defn on-init [props]
  (let [group-id        (get-in props [:params :group-id])
        diffs-group-id  (and (get-in props [:query :compare])
                             (get-in props [:query :group-id]))
        active-env-id   @(re-posh/subscribe [:app.subs/get-local-storage "environments-panel-active-id"])
        handle-envs?    @(re-posh/subscribe [:unleash/is-enabled "fe.environments"])
        sort-options    (-> @(re-posh/subscribe [:app.subs/get-local-storage "groups-panel-sort"])
                            (js->clj :keywordize-keys true))
        transform-sort-options (-> @(re-posh/subscribe [:app.subs/get-local-storage "transforms-panel-sort"])
                                   (js->clj :keywordize-keys true))

        group-panel     (cond-> {:groups-panel/order-by  (:order-by sort-options)
                                 :groups-panel/order-dir (:order-dir sort-options)}
                          (some? group-id)
                          (assoc :groups-panel/active-group {:group/id group-id}))]

    ;; Add group models
    (dispatch [:groups-panel/add group-panel])

    (dispatch [:transformations-view/add])
    (dispatch [:transformations-search/add])
    (dispatch [:transforms-panel/add {:transforms-panel/order-by (keyword (:order-by transform-sort-options))
                                      :transforms-panel/order-dir (keyword(:order-dir transform-sort-options))}])


    ;; Environments
    (when handle-envs?
      (dispatch-sync [:environments-panel/add (->environments-panel {:active-id active-env-id})])
      (dispatch [:environments.api/fetch-environments])

      (when diffs-group-id
        (dispatch [:environments.api/fetch-diff-transforms {:group-id diffs-group-id}])))


    ;; Fetch required data
    (dispatch-sync [:users.api/fetch-searchable-users])

    ;; Fetch minor data
    (dispatch [:dag.events/load-dag-data])
    (dispatch [:transformations.api/cyclic-deps-check {:show-warnings true}])
    (dispatch [:transformations.api/fetch-tags])

    (dispatch [:environments.api/fetch-groups])))

(defn on-update [props old-props]
  (let [group-id     (get-in props [:params :group-id])
        old-group-id (get-in old-props [:params :group-id])
        query        (:query props)
        query-old    (:query old-props)
        prod-active? @(re-posh/subscribe [:environments.subs/production-active?])]
    (when (and (not prod-active?)
               (or (:merge query) (:compare query))
               (not= (:group-id query) (:group-id query-old)))
      (dispatch [:environments.api/fetch-diff-transforms {:group-id (:group-id query)}]))

    (when-not (= old-group-id group-id)
      (let [group-panel     {:groups-panel/active-group {:group/id group-id}}
            transform-sort-options (-> @(re-posh/subscribe [:app.subs/get-local-storage "transforms-panel-sort"])
                                       (js->clj :keywordize-keys true))
            transform-panel {:transforms-panel/active-transform nil
                             :transforms-panel/transforms       nil
                             :transforms-panel/order-by         (keyword (:order-by transform-sort-options))
                             :transforms-panel/order-dir        (keyword (:order-dir transform-sort-options))}]
        (dispatch-sync [:groups-panel/update group-panel {:replace true}])
        (dispatch-sync [:transforms-panel/update transform-panel {:replace true}])))))

(defn main-render [props]
  (let [group-id (get-in props [:params :group-id])
        env-id   @(re-posh/subscribe [:environments.subs/active-environment-id])]
    [:<>
     [page-root {:class "grid grid-rows-[auto_1fr] min-h-0 h-screen overflow-hidden"}
      [page-header {:variant :border}
       [header]]
      [page-content {:variant :border}
       [:div {:class "grid grid-cols-[300px_1fr] 2xl:grid-cols-[400px_1fr] h-full relative overflow-hidden"}
        ^{:key (str "groups-" env-id)}
        [groups-sidebar]
        (when group-id
          ^{:key (str "transforms-" env-id)}
          [transforms {:group-id group-id}])]]]]))


(defn main []
  (reagent/create-class
   {:display-name
    "transformations"

    :constructor
    (fn [this]
      (on-init (reagent/props this)))

    :component-did-update
    (fn [this [_ old-props]]
      (let [props (reagent/props this)]
        (on-update props old-props)))

    :component-will-unmount
    (fn []
      (dispatch-sync [:environments-panel/delete])
      (dispatch-sync [:groups-panel/delete])
      (dispatch-sync [:transforms-panel/delete]))

    :render
    (fn [this]
      [main-render (reagent/props this)])}))
